import { useEffect } from "react";
import { SITE_URL } from "@/lib/schema";

/**
 * Lightweight head manager for a CRA SPA: sets title, meta description,
 * canonical, Open Graph tags and injects JSON-LD schema blocks.
 */
export default function Seo({ title, description, path = "/", schema = [] }) {
  useEffect(() => {
    document.title = title;
    const canonical = `${SITE_URL}${path}`;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
      return el;
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", `${SITE_URL}/assets/bwg-logo.png`);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    const scripts = schema.map((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "true");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });

    return () => scripts.forEach((s) => s.remove());
  }, [title, description, path, schema]);

  return null;
}
